
import HOAHero from './components/HOAHero';
import MarketResearch from './components/MarketResearch';
import UserEcosystem from './components/UserEcosystem';
import PainPoints from './components/PainPoints';
import UXPrinciples from './components/UXPrinciples';
import WorkflowArchitecture from './components/WorkflowArchitecture';
import UXSolutions from './components/UXSolutions';
import BusinessImpact from './components/BusinessImpact';
import HOAOutcomes from './components/HOAOutcomes';
import Learnings from './components/Learnings';

export default function HOACaseStudy() {
  return (
    <div className="min-h-screen bg-[#FAFBFC]">
      <HOAHero />
      <MarketResearch />
      <UserEcosystem />
      <PainPoints />
      <UXPrinciples />
      <WorkflowArchitecture />
      <UXSolutions />
      <BusinessImpact />
      <HOAOutcomes />
      <Learnings />
    </div>
  );
}
